import { useEffect, useState } from 'react';
import { getUsageForBlueprint } from '../../../services/metrics.service';

interface UsageStatsTabProps {
  blueprintId: string;
  organizationId: string;
}

export function UsageStatsTab({ blueprintId, organizationId }: UsageStatsTabProps) {
  const [usage, setUsage] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getUsageForBlueprint(blueprintId, organizationId)
      .then((count) => {
        if (cancelled) return;
        setUsage(count);
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [blueprintId, organizationId]);

  if (loading) return <div className="text-sm text-gray-500">Carregando...</div>;
  if (error) return <div className="text-sm text-red-600 dark:text-red-300">{error}</div>;

  return (
    <div className="space-y-2 text-sm">
      <div className="text-gray-500">Uso total</div>
      <div className="text-3xl font-semibold">{usage ?? 0}</div>
      <div className="text-gray-500">Instâncias de fluxo criadas a partir deste blueprint.</div>
    </div>
  );
}
